import { render } from "./CanalVentaCreate.vue?vue&type=template&id=0e846e7d&scoped=true"
import script from "./CanalVentaCreate.vue?vue&type=script&lang=js"
export * from "./CanalVentaCreate.vue?vue&type=script&lang=js"

import "./CanalVentaCreate.vue?vue&type=style&index=0&id=0e846e7d&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e846e7d"]])

export default __exports__